import { IconName, PButtonPure, PText } from '@porsche-design-system/components-react'
import React from 'react'
import { UseFormMethods } from 'react-hook-form'
import { InterfaceType } from 'typescript'

import styles from './inputWithButton.module.css'

type Props = {
  textFieldName: string
  buttonIcon?: IconName
  buttonFunction?: (funcVal: any) => void
  buttonDescription?: string
  textFieldPlaceholder?: string
  textFieldMethods: any
  textFieldOnKeyPress?: (e: any) => void
  labelText?: string
}

const InputWithButton = ({
  labelText,
  buttonIcon,
  buttonFunction,
  textFieldPlaceholder,
  textFieldName,
  buttonDescription,
  textFieldOnKeyPress,
  textFieldMethods
}: Props) => {
  React.useEffect(() => {
    textFieldMethods.register(textFieldName)
  }, [textFieldMethods])

  return (
    <div className={styles.textFieldWrapper}>
      <label className={styles.labelText}>
        <PText>{labelText}</PText>
      </label>
      <input
        type='text'
        name={textFieldName}
        className={styles.textField}
        placeholder={textFieldPlaceholder}
        ref={textFieldMethods.register}
        onKeyPress={textFieldOnKeyPress}
      />
      <PButtonPure className={styles.textFieldButton} icon={buttonIcon} hideLabel onClick={buttonFunction}>
        {buttonDescription}
      </PButtonPure>
    </div>
  )
}

export default InputWithButton
